import React from "react"
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ActivityIndicator
} from "react-native"
import Feather from "@expo/vector-icons/Feather";
import { COLORS } from "../../screens/tenants/tenantOnboarding/screens/components/PropertyDetailsCard";
interface Props {
  showLeft?: boolean
  showRight?: boolean
  leftLabel?: string
  rightLabel?: string
  onLeftPress?: () => void
  onRightPress?: () => void
  rightDisabled?: boolean
  rightLoading?: boolean
}

export default function WizardFooter({
  showLeft = true,
  showRight = true,
  leftLabel = "Back",
  rightLabel = "Next",
  onLeftPress,
  onRightPress,
  rightDisabled = false,
  rightLoading = false
}: Props) {

  return (
    <View style={styles.footer}>

      {showLeft ? (
       <TouchableOpacity
       onPress={onLeftPress}
       style={styles.leftButton}
     >
       <Feather name="arrow-left" size={16} color="#6D08C0" />
       <Text style={styles.leftText}>{leftLabel}</Text>
     </TouchableOpacity>
     
      ) : (
        <View />
      )}

      {showRight && (
        <TouchableOpacity
          style={[
            styles.rightButton,
            rightDisabled && styles.disabledButton
          ]}
          disabled={rightDisabled || rightLoading}
          onPress={onRightPress}
        >
          {rightLoading ? (
            <ActivityIndicator color="#fff" size="small" />
          ) : (
            <Text style={styles.rightText}>{rightLabel}</Text>
          )}
        </TouchableOpacity>
      )}

    </View>
  )
}

const styles = StyleSheet.create({

  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 18,
    paddingHorizontal: 24,
  },

  leftButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 8,
    backgroundColor: "#F3E8FF",
  },
  
  leftText: {
    color:COLORS.primary,
    fontWeight: "600",
  },
  

  rightButton: {
    backgroundColor: COLORS.primary,
    paddingVertical: 12,
    paddingHorizontal: 30,
    borderRadius: 10,
  },

  disabledButton: {
    backgroundColor: "#D1D5DB",
  },

  rightText: {
    color: "#fff",
    fontWeight: "700",
    fontSize: 14,
  },
})
